import { useCallback } from 'react';

import { BUCK_EVENTS } from '../../../utils/analytics';
import type { AnalyticsHandler } from '../../SignupDrawer/hooks/useSignupFlow';

type UseConfirmationStepOptions = {
  onDone: () => void;
  onAnalyticsEvent?: AnalyticsHandler;
};

type UseConfirmationStepReturn = {
  handleDone: () => void;
};

/**
 * Provides confirmation-step data and completion behavior for LT Plus flow.
 */
export const useConfirmationStep = ({
  onDone,
  onAnalyticsEvent,
}: UseConfirmationStepOptions): UseConfirmationStepReturn => {
  const handleDone = useCallback(() => {
    onAnalyticsEvent?.(BUCK_EVENTS.LT_PLUS_CONFIRMATION_DONE_CLICKED, {});
    onDone();
  }, [onAnalyticsEvent, onDone]);

  return {
    handleDone,
  };
};
